import { render, staticRenderFns } from "./ProjectsNewEdit.vue?vue&type=template&id=7cbd6984"
import script from "./ProjectsNewEdit.vue?vue&type=script&lang=js"
export * from "./ProjectsNewEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports